'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchImpl = fetchImpl;

var _PatchResolver = require('./PatchResolver');

var _getBoundary = require('./getBoundary');

function fetchImpl(url, _ref) {
    var method = _ref.method,
        headers = _ref.headers,
        credentials = _ref.credentials,
        body = _ref.body,
        onNext = _ref.onNext,
        onError = _ref.onError,
        onComplete = _ref.onComplete;

    return fetch(url, { method: method, headers: headers, body: body, credentials: credentials }).then(function (response) {
        var contentType = !!response.headers && response.headers.get('Content-Type') || '';
        // @defer uses multipart responses to stream patches over HTTP
        if (response.status < 300 && contentType.indexOf('multipart/mixed') >= 0) {
            var boundary = (0, _getBoundary.getBoundary)(contentType);

            // For the majority of browsers with support for ReadableStream and TextDecoder
            var reader = response.body.getReader();
            var textDecoder = new TextDecoder();
            var patchResolver = new _PatchResolver.PatchResolver({
                onResponse: function onResponse(r) {
                    return onNext(r, { responseHeaders: response.headers });
                },
                boundary: boundary
            });
            return reader.read().then(function sendNext(_ref2) {
                var value = _ref2.value,
                    done = _ref2.done;

                if (!done) {
                    var plaintext = void 0;
                    try {
                        plaintext = textDecoder.decode(value);
                        // Read the header to get the Content-Length
                        patchResolver.handleChunk(plaintext);
                    } catch (err) {
                        var parseError = err;
                        parseError.response = response;
                        parseError.statusCode = response.status;
                        parseError.bodyText = plaintext;
                        onError(parseError);
                    }
                    reader.read().then(sendNext);
                } else {
                    onComplete();
                }
            });
        } else {
            return response.json().then(function (json) {
                onNext([json], { responseHeaders: response.headers });
                onComplete();
            });
        }
    }).catch(onError);
}